export default "__VITE_ASSET__DvW8sBke__"